import { SITE_LAYOUT } from 'config/siteLayout';

import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  contentTitle: {
    maxWidth: SITE_LAYOUT.contentMaxWidth,
    [theme.breakpoints.down('md')]: {
      maxWidth: '300px',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '250px',
    },
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'auto',
  },
  link: {
    wordBreak: 'break-all',
  },
  image: {
    width: '55vw',
    [theme.breakpoints.up('md')]: {
      width: '300px',
    },
    objectFit: 'cover',
  },
  titleGroup: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(0.5),
  },
  submissionLivePost: {
    width: '100%',
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
  },
  viewStack: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2),
  },
  submissionDetails: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(3), // 24px
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2), // 16px
  },
  agreement: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(2), // 16px
  },
  creditContainer: {
    width: '75%',
    height: 'auto',
  },
  defaultLink: {
    color: theme.palette.secondary.main,
  },
  submissionSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: theme.spacing(0.5),
  },
  credits: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: theme.spacing(2), // 16px
  },
  livePostInner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  agreementRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  closeRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
